import administrativeClericalImg from "@assets/jobs/administrative-clerical.jpg";
import callCenterImg from "@assets/jobs/Call-center.jpg";
import engineeringImg from "@assets/jobs/engineering.jpg";
import eventsImg from "@assets/jobs/Events.jpg";
import fnBImg from "@assets/jobs/FnB.jpg";
import managementImg from "@assets/jobs/management.jpg";
import marketingImg from "@assets/jobs/marketing.jpg";
import publicCivilServiceImg from "@assets/jobs/public-civil-service.jpg";
import receptionistImg from "@assets/jobs/Receptionist.jpg";
import retailImg from "@assets/jobs/Retail.jpg";
import servicesImg from "@assets/jobs/services.jpg";
import warehousingImg from "@assets/jobs/warehousing.jpg";

export const JOBS_CATEGORY_DATA = [
  {
    category_order: 1,
    category_url: "engineering",
    st_job_slug:
      "technology-digital-development,engineering-newspaper-production",
    stclassified_id: "",
    fastjobs_category: "",
    mycareersfuture_jobs_category: "Engineering,Information+Technology",
    job_category_tamil: "பொறியியல் (PMET)",
    job_category_english: "Engineering",
    is_published: 1,
    category_image: engineeringImg,
  },
  {
    category_order: 2,
    category_url: "marketing",
    st_job_slug: "",
    stclassified_id: "",
    fastjobs_category: "",
    mycareersfuture_jobs_category: "Marketing / Public Relations",
    job_category_tamil: "சந்தைப்படுத்தல் / மக்கள் தொடர்பு (PMET)",
    job_category_english: "Marketing/Public Relations",
    is_published: 1,
    category_image: marketingImg,
  },
  {
    category_order: 3,
    category_url: "general-management",
    st_job_slug: "",
    stclassified_id: "",
    fastjobs_category: "",
    mycareersfuture_jobs_category: "General Management",
    job_category_tamil: "பொது மேலாண்மை (PMET)",
    job_category_english: "General Management",
    is_published: 1,
    category_image: managementImg,
  },
  {
    category_order: 4,
    category_url: "professional-services",
    st_job_slug: "",
    stclassified_id: "",
    fastjobs_category: "",
    mycareersfuture_jobs_category: "Professional Services",
    job_category_tamil: "நிபுணத்துவ சேவைகள்",
    job_category_english: "Professional Services",
    is_published: 1,
    category_image: servicesImg,
  },
  {
    category_order: 5,
    category_url: "public-civil-service",
    st_job_slug: "",
    stclassified_id: "",
    fastjobs_category: "",
    mycareersfuture_jobs_category: "Public / Civil Service",
    job_category_tamil: "பொதுச் சேவைத் துறை (PMET)",
    job_category_english: "Public / Civil Service",
    is_published: 1,
    category_image: publicCivilServiceImg,
  },
  {
    category_order: 11,
    category_url: "administrative-clerical",
    st_job_slug: "finance-corporate-development-admin-procurement",
    stclassified_id: "748",
    fastjobs_category: "12",
    mycareersfuture_jobs_category: "",
    job_category_tamil: "அலுவலக நிர்வாகம் / எழுத்தர் பணி",
    job_category_english: "Administrative / Clerical",
    is_published: 1,
    category_image: administrativeClericalImg,
  },
  {
    category_order: 12,
    category_url: "customer-service-receptionists",
    st_job_slug: "consumer-engagement-customer-experience",
    stclassified_id: "7360,7330",
    fastjobs_category: "8",
    mycareersfuture_jobs_category: "",
    job_category_tamil: "வாடிக்கையாளர் சேவை / வரவேற்பாளர்கள்",
    job_category_english: "Cust. Service / Receptionists",
    is_published: 1,
    category_image: receptionistImg,
  },
  {
    category_order: 13,
    category_url: "call-centres-telemarketing",
    st_job_slug: "",
    stclassified_id: "7340",
    fastjobs_category: "6",
    mycareersfuture_jobs_category: "",
    job_category_tamil: "அழைப்பு மையங்கள் / டெலிமார்க்கெட்டிங்",
    job_category_english: "Call Centres / Telemarketing",
    is_published: 1,
    category_image: callCenterImg,
  },
  {
    category_order: 14,
    category_url: "hospitality-fb",
    st_job_slug: "",
    stclassified_id: "7210,1340,1350",
    fastjobs_category: "11",
    mycareersfuture_jobs_category: "",
    job_category_tamil: "விருந்தோம்பல் / உணவு, பானத்துறை",
    job_category_english: "Hospitality / F&B",
    is_published: 1,
    category_image: fnBImg,
  },
  {
    category_order: 15,
    category_url: "sales-retail-marketing",
    st_job_slug: "media-sales-solutions-marketing",
    stclassified_id: "7300,7310,2640,7270",
    fastjobs_category: "16",
    mycareersfuture_jobs_category: "",
    job_category_tamil: "விற்பனை / சில்லறை வர்த்தகம் / விளம்பரத்துறை",
    job_category_english: "Sales / Retail / Marketing",
    is_published: 1,
    category_image: retailImg,
  },
  {
    category_order: 16,
    category_url: "temporary-events",
    st_job_slug: "",
    stclassified_id: "7830,100,120,180,190",
    fastjobs_category: "19",
    mycareersfuture_jobs_category: "",
    job_category_tamil: "தற்காலிகப் பணி / நிகழ்ச்சி ஏற்பாடு",
    job_category_english: "Temporary / Events",
    is_published: 1,
    category_image: eventsImg,
  },
  {
    category_order: 17,
    category_url: "warehousing-logistics",
    st_job_slug: "",
    stclassified_id: "7630,2240,2390,1610",
    fastjobs_category: "21",
    mycareersfuture_jobs_category: "",
    job_category_tamil: "சேமிப்புக்கிடங்கு & தளவாடங்கள் துறை",
    job_category_english: "Warehousing & Logistics",
    is_published: 1,
    category_image: warehousingImg,
  },
];
